// extracted by css-extract-rspack-plugin
export default {"cls1":"shared-cls1_ueQ","cls2":"shared-cls2_KDI shared-cls1_ueQ"};